
import React from 'react';

const Spacing = () => React.createElement("div", { className: "spacing" });

Spacing.displayName = 'Spacing';

export default Spacing;